namespace B2B.UI {
    export interface IWhatsAppPopupOptions {
    }
    export class WhatsAppPopup extends B2B.UI.Popup{
        private _options: IWhatsAppPopupOptions;
        private _resolve: (data: IPopupResult) => any;

        constructor(options?: IWhatsAppPopupOptions) {
            super();
            this._options = options;
            this.element.classList.add("b-popup-whatsapp");
        }

        protected override onClose(){
            if(this._resolve) {
                this._resolve({ action: "cancel", data: null });
            }
        }

        public override show() : Promise<IPopupResult> {
            let instance = this;
            let popupContentElement = <HTMLElement>document.querySelector(".js-popup_whatsapp form");
            let copy = <HTMLElement>popupContentElement.cloneNode(true);
            copy.style.display = "";

            this.setContent(copy);
            super.show();

            // @ts-ignore
            if(TextBack){
                // init textback widget
                let widgetNodes = this.element.querySelectorAll("tb-notification-widget");
                if(widgetNodes.length){
                    let widgetNode = widgetNodes[0];
                    widgetNode.textContent = '';

                    // @ts-ignore
                    new TextBack.NotificationWidget({element: widgetNode});
                }
            }

            return new Promise<IPopupResult>((resolve) => {
                instance._resolve = resolve;
            });
        }
    }
}